import { useEffect, useState } from "react";
import AccessModuleService from "../../services/AccessModuleService";
import { useUserStore } from "../../contexts/userStore";
import Select from "../Select/Select";
import { listRfSlots } from "../../helpers/AccessPointParser";
import { useTranslation } from "react-i18next";

export function SelectAccessModule({ accessModule, onChange, labelText, useUuid = false, ...props }) {
   const [accessModules, setAccessModules] = useState([]);
   const { selectedCondominio } = useUserStore();
   const { t } = useTranslation();

   async function fetchModules() {
      try {
         const { data: modules } = await AccessModuleService.listByCondominium(selectedCondominio);
         setAccessModules(listRfSlots(modules));
      } catch (err) {
         console.error(err);
      }
   }

   useEffect(() => {
      fetchModules();
   }, [selectedCondominio]);

   return (
      <Select
         labelText={labelText === false ? "" : t("equipment.associatedAccess") + "*"}
         value={accessModule}
         onChange={({ target }) => {
            onChange?.(target.value)
         }}
         disabled={props.formMode === "consulta"}
         required={false}
         options={[
            ...accessModules?.map(accessModule => ({ value: accessModule.subModuleIndex !== undefined ? `${useUuid ? accessModule.uuid : accessModule.id}:${accessModule.subModuleIndex}` : `${useUuid ? accessModule.uuid : accessModule.id}`, text: accessModule.name }))
         ]}
      />
   );
}